// Module
var code = "<div class=sidebar-inner ls-left-sidebar> </div> ";
// Exports
module.exports = code;